<template>
  <div>
    <v-row
      class="mt-2"
      align="center"
    >
      <v-spacer />
      <v-col
        cols="auto"
        class="text-subtitle-1 grey--text pr-2"
      >
        {{ $t("picker.date.placeholder") }}:
      </v-col>
      <v-col
        cols="auto"
        class="d-flex align-center"
      >
        <v-btn
          icon
          @click="date = $dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')"
        >
          <v-icon small>
            fa fa-arrow-left
          </v-icon>
        </v-btn>
        <v-menu
          v-model="calendarActive"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateLabel"
              :label="$t('filter_by_date.label')"
              solo
              dense
              hide-details
              style="width: 250px"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date"
            :first-day-of-week="1"
            no-title
            @change="calendarActive = false"
          />
        </v-menu>
        <v-btn
          icon
          @click="date = $dayjs(date).add(1, 'day').format('YYYY-MM-DD')"
        >
          <v-icon small>
            fa fa-arrow-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider class="mt-5" />
    <div
      style="height: 1px"
      class="mb-5"
    >
      <v-progress-linear
        v-if="stats.loading"
        indeterminate
        height="1px"
      />
    </div>

    <v-row
      v-if="stats.data && stats.data.smart_assistant && stats.data.smart_assistant.length"
      class="mb-8"
    >
      <v-col
        v-for="alert in stats.data.smart_assistant"
        :key="alert.id"
        cols="3"
      >
        <v-card
          class="fill-height rounded-lg"
          flat
        >
          <v-card-text class="py-5 px-4">
            <v-row
              no-gutters
              align="center"
            >
              <v-col>
                <div
                  class="font-weight-medium text-subtitle-1 grey--text text--darken-2"
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                >
                  {{ alert.label }}
                </div>
              </v-col>
              <v-col cols="auto">
                <v-icon
                  small
                  color="primary"
                >
                  far fa-triangle-exclamation
                </v-icon>
              </v-col>
            </v-row>
            <div class="text-body-1 mt-4">
              {{ alert.recommendation }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-else
      justify="center"
    >
      <v-col
        cols="auto"
        class="grey--text"
      >
        {{ $t("smart_assistant.no_alerts") }}
      </v-col>
    </v-row>
  </div>
</template>

<script>

import dayjs from 'dayjs'
import { PlayerApiService } from '@/data/services'

export default {
  name: 'PlayerSmartAssistantAlertsView',
  components: { },
  props: {
    player: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    stats: {
      data: null,
      loading: false,
      pagination: {
        page: 1,
        per_page: 25,
        last_page: 1
      }
    },
    date: dayjs().format('YYYY-MM-DD'),
    calendarActive: false
  }),
  computed: {
    dateLabel() {
      return this.$dayjs(this.date).format('ll')
    }
  },
  watch: {
    date: function () {
      this.fetchPlayerStats()
    }
  },
  created() {
    this.fetchPlayerStats()
  },
  methods: {
    fetchPlayerStats: async function () {
      this.stats.loading = true

      try {
        const response = await PlayerApiService.getStats(this.player.id, {
          page: this.stats.pagination.current_page,
          per_page: this.stats.pagination.per_page,
          date_from: dayjs(this.date).format('YYYY-MM-DD'),
          date_to: dayjs(this.date).format('YYYY-MM-DD')
        })

        this.stats.data = response.data[0]
        this.stats.pagination = response.meta
      } catch (e) {
        this.stats.data = []
        throw e
      } finally {
        this.stats.loading = false
      }
    }
  }
}

</script>

<style scoped>

</style>
